import { render, staticRenderFns } from "./ownerDetail.vue?vue&type=template&id=2b2135fc&scoped=true"
import script from "./ownerDetail.vue?vue&type=script&lang=js"
export * from "./ownerDetail.vue?vue&type=script&lang=js"
import style0 from "./ownerDetail.vue?vue&type=style&index=0&id=2b2135fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2135fc",
  null
  
)

export default component.exports